import { render, staticRenderFns } from "./ComprehensiveDiv.vue?vue&type=template&id=5e6bd609&scoped=true&"
import script from "./ComprehensiveDiv.vue?vue&type=script&lang=ts&"
export * from "./ComprehensiveDiv.vue?vue&type=script&lang=ts&"
import style0 from "./ComprehensiveDiv.vue?vue&type=style&index=0&id=5e6bd609&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6bd609",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow})
